import React from 'react';
import "external-svg-loader";

export const getPittogramma = (url: string, tooltip: string) => {
    if (!url) {
      return;
    }
    /* @ts-ignore */
    return <Pittogramma src={url} alt={tooltip}/>
}

const Pittogramma = ({
  src,
  ...props
}: React.SVGProps<SVGSVGElement> & { src?: string }) => (
    <svg
    data-src={src}
    data-cache="7200000"
    data-lazy="lazy"
    width="50px"
    height="50px"
    {...props}
  />
)